module.exports = __webpack_public_path__ + "img/insurita-faqs-bottom.2f6703d3.svg";